module.exports = __webpack_public_path__ + "img/1.b6f8e8c9.png";